module.exports = __webpack_public_path__ + "img/cta_desktop.b8802c55.png";